import React from 'react';
import './index.scss';
const Ad = () => {
  // const [current, setCurrent] = useState(0)
  const insertFBTrackScript = function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }
  insertFBTrackScript(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '3242946979352321');
  window.fbq('track', 'PageView');
  const links = {
    offical: {
      url: "https://vr.starmakerstudios.com/",
      track: 'officialsitebuttonclick'
    },
    oculus: {
      url: "https://www.oculus.com/experiences/quest/4997511816936942/",
      track: 'oculusbuttonclick'
    },
    steam: {
      url: "https://store.steampowered.com/app/2020670/StarMaker_VR/",
      track: 'steambuttonclick'
    }
  }
  const goPage = (type) => {
    window.fbq('track', links[type].track);
    window.gtag_report_conversion(links[type].url, "_blank");
    // window.gtag('event', 'conversion', {
    //   send_to: 'AW-11020367197/1fyjCJXXvpEYEN3q9YYp',
    //   event_callback: callback,
    // })
    //  window.open(links[type].url, "_blank")
  }

  return (
    <div className="ad">
      <img className='people' src="https://starvr-cdn.starmakerstudios.com/webimg/ad/avatar.png" alt="" />
      <img className='logo' src="https://starvr-cdn.starmakerstudios.com/webimg/ad/logo.png" alt="" />
      <img className='site' src="https://starvr-cdn.starmakerstudios.com/webimg/ad/site.png" alt="" onClick={() => goPage('offical')} />
      <img className='oculus' src="https://starvr-cdn.starmakerstudios.com/webimg/ad/oculus.png" alt="" onClick={() => goPage('oculus')} />
      <img className='steam' src="https://starvr-cdn.starmakerstudios.com/webimg/ad/steam.png" alt="" onClick={() => goPage('steam')} />
    </div>
  );
}

export default Ad;
